import React from "react";
import { Image } from "antd";
import styled from "styled-components";

/** Square size for images inside sent message bubbles (tap to expand). */
export const CHAT_MESSAGE_IMAGE_THUMB_PX = 56;

const THUMB_STYLES = {
  root: {
    display: "inline-block",
    width: CHAT_MESSAGE_IMAGE_THUMB_PX,
    height: CHAT_MESSAGE_IMAGE_THUMB_PX,
    lineHeight: 0,
    flexShrink: 0,
  },
  image: {
    width: CHAT_MESSAGE_IMAGE_THUMB_PX,
    height: CHAT_MESSAGE_IMAGE_THUMB_PX,
    borderRadius: 8,
    objectFit: "cover",
    border: "1px solid #dadce0",
    background: "#f8fafc",
    cursor: "pointer",
  },
};

const Strip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
  margin-bottom: ${(p) => (p.$marginBottom ? "8px" : "0")};
  margin-top: ${(p) => (p.$marginTop ? "0.5rem" : "0")};
  ${(p) =>
    p.$alignEnd ? "align-self: flex-end; margin-left: auto;" : ""}
`;

function resolveImageUrl(imageUrl) {
  if (typeof imageUrl === "string") return imageUrl;
  return imageUrl?.url || imageUrl?.src || "";
}

/**
 * Compact image row for user/landlord/homeowner chat bubbles.
 * Click or tap any thumb to open the full-size Ant Design preview.
 */
export default function ChatMessageImageThumbs({
  images,
  altPrefix = "Attachment",
  marginBottom = false,
  marginTop = false,
  alignEnd = false,
}) {
  const urls = (images || []).map(resolveImageUrl).filter(Boolean);
  if (!urls.length) return null;

  return (
    <Strip
      $marginBottom={marginBottom}
      $marginTop={marginTop}
      $alignEnd={alignEnd}
    >
      <Image.PreviewGroup>
        {urls.map((src, idx) => (
          <Image
            key={`${src}-${idx}`}
            src={src}
            alt={`${altPrefix} ${idx + 1}`}
            width={CHAT_MESSAGE_IMAGE_THUMB_PX}
            height={CHAT_MESSAGE_IMAGE_THUMB_PX}
            styles={THUMB_STYLES}
            preview={{ mask: "View" }}
          />
        ))}
      </Image.PreviewGroup>
    </Strip>
  );
}
